import { gql } from '@apollo/client';

// GraphQL Query
export const GET_CONTACT_FINTRX = gql`
  query GetContactFintrxByContact($contactId: ID!) {
    contact(id: $contactId) {
      id
      name
      fintrxIds {
        id
        fintrxBestMatchCompany
        fintrxBestMatchName
        fintrxCompanyScore
        fintrxContactCrdId
        fintrxInvestmentCommitteeMember
        fintrxNameScore
        fintrxRegisteredStatus
      }
    }
  }
`;

// UI Data Types
export interface ContactFintrxData {
  bestMatchCompany: string;
  bestMatchName: string;
  companyScore: null | number;
  contactCrdId: string;
  investmentCommitteeMember: boolean;
  nameScore: null | number;
  registeredStatus: boolean;
}

export interface ContactNodeWithFintrx {
  fintrxIds?: FintrxNode | FintrxNode[] | null;
  id: string;
  name: string;
}

// API Response Types
export interface FintrxNode {
  fintrxBestMatchCompany?: null | string;
  fintrxBestMatchName?: null | string;
  fintrxCompanyScore?: null | number;
  fintrxContactCrdId?: null | string;
  fintrxInvestmentCommitteeMember?: boolean | null;
  fintrxNameScore?: null | number;
  fintrxRegisteredStatus?: boolean | null;
  id: string;
}

// Helper functions
export function createEmptyContactFintrxData(): ContactFintrxData {
  return {
    bestMatchCompany: '',
    bestMatchName: '',
    companyScore: null,
    contactCrdId: '',
    investmentCommitteeMember: false,
    nameScore: null,
    registeredStatus: false
  };
}

export function mapContactFintrx(node: FintrxNode): ContactFintrxData {
  return {
    bestMatchCompany: node.fintrxBestMatchCompany ?? '',
    bestMatchName: node.fintrxBestMatchName ?? '',
    companyScore: node.fintrxCompanyScore ?? null,
    contactCrdId: node.fintrxContactCrdId ?? '',
    investmentCommitteeMember: node.fintrxInvestmentCommitteeMember ?? false,
    nameScore: node.fintrxNameScore ?? null,
    registeredStatus: node.fintrxRegisteredStatus ?? false
  };
}
